import { toaster } from 'uikit/Toaster'
import { useStore } from '@tanstack/react-store'
import { api } from 'api'
import { useQuery } from '@tanstack/react-query'
import { bannerListStore } from 'shared/store'

export const useFetchBanners = () => {
  const store = useStore(bannerListStore)

  const response = useQuery({
    queryKey: ['bannersList', store],
    queryFn: () => api.banner.fetchList(store),
    gcTime: 0,
  })

  if (response.isError) {
    toaster.create({
      title: 'Произошла ошибка при загрузке баннеров',
      description: response.error?.message,
      type: 'error',
    })
  }

  return response
}
